(() => {
  // src/js/azure-integration.js
  function callAzure(endpoint, body) {
    return fetch(window.azureIntegration.endpoint + endpoint, {
      method: "POST",
      ContentType: "application/json",
      headers: {
        "Content-Type": "application/json",
        "X-Signature": window.azureIntegration.signature,
        "X-SignatureBody": window.azureIntegration.signatureBody
      },
      body: JSON.stringify(body)
    }).then((response) => {
      if (response.ok) {
        if (response.headers.get("content-type")) {
          return response.json();
        }
        return true;
      } else {
        throw response;
      }
    });
  }
  window.callAzure = callAzure;
})();
